import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=496c8c14&scoped=true"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=496c8c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c8c14",
  null
  
)

export default component.exports